export default {
  MARK_AS_DEFAULT: 'MARK_AS_DEFAULT',
} as const
